import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import appConfig from '../../../../app-config';
import { useSelector } from 'react-redux';
const Wrapper = styled.div``;
const Title = styled.div`
  font-size: 32px;
  text-transform: uppercase;
  font-weight: 600;
`;
const Message = styled.div`
  font-size: 18px;
`;
export const LoyaltyRegistrationMessages = ({
  registrationStep = 'welcome',
}) => {
  const { requestingNewDigitalCard } = useSelector(
    (state) => state.loyaltyReducer
  );
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (registrationStep === 'welcome') {
      setTitle(appConfig.loyaltyRegistrationWelcomeTitle);
      setMessage(appConfig.loyaltyRegistrationWelcomeSubtitle);
    } else if (registrationStep === 'link') {
      setTitle(appConfig.loyaltyRegistrationLinkTitle);
      setMessage(appConfig.loyaltyRegistrationLinkSubtitle);
    } else if (registrationStep === 'new_card') {
      if (requestingNewDigitalCard) {
        setTitle(appConfig.loyaltyRegistrationCreatingNewCardTitle);
        setMessage(appConfig.loyaltyRegistrationCreatingNewCardSubtitle);
      } else {
        setTitle(appConfig.loyaltyRegistrationCompletedTitle);
        setMessage(appConfig.loyaltyRegistrationCompletedSubtitle);
      }
    }
  }, [registrationStep, requestingNewDigitalCard]);
  return (
    <Wrapper>
      <Title>{title}</Title>
      <Message>{message}</Message>
    </Wrapper>
  );
};
